import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';

const CancellationRefundPolicy = () => {
  return (
    <Box sx={{ bgcolor: '#FAFAFA', minHeight: '100vh' }}>
      <NavBar />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: '16px' }}>
          <Typography variant="h3" gutterBottom sx={{ color: '#FF6B35', fontWeight: 'bold', mb: 3 }}>
            Cancellation and Refund Policy
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            At YoungPresso, we strive to provide the best experience for our young readers and their parents. 
            This policy outlines our guidelines for subscription cancellations and refunds.
          </Typography>

          <Typography variant="h4" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 5, mb: 3 }}>
            Cancellation Policy
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            1. Subscription Cancellation
          </Typography>
          <Typography variant="body1" paragraph>
            You may cancel your subscription at any time by sending an email to: <b>info@youngpresso.com</b>. Please provide your registered email address and a reason for cancellation. 
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            2. Effective Date of Cancellation
          </Typography>
          <Typography variant="body1" paragraph>
            When you cancel your subscription, you will continue to have access to YoungPresso services until the end of 
            your current billing period. After that, your subscription will not renew, and your account will not get charged any further.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            3. Auto-Renewal
          </Typography>
          <Typography variant="body1" paragraph>
            All subscriptions are set to auto-renew by default. If you wish to prevent automatic renewal, you must cancel 
            your subscription at least 48 hours before the end of your current billing period.
          </Typography>

          <Divider sx={{ my: 5 }} />

          <Typography variant="h4" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 5, mb: 3 }}>
            Refund Policy
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            No Refund Policy
          </Typography>
          <Typography variant="body1" paragraph>
            YoungPresso operates on a <b>subscription-based model</b>. Once a subscription payment has been charged, 
            <b> no refunds will be provided</b> for the charged amount. This policy applies to all subscription plans, 
            including monthly, quarterly, half-yearly, and annual subscriptions.
          </Typography>

          <Typography variant="body1" paragraph>
            However, you may cancel your subscription at any time to prevent future charges. Upon cancellation, 
            you will continue to have access to YoungPresso content until the end of your current billing period, 
            after which no further charges will be applied to your account.
          </Typography>

          <Typography variant="body1" paragraph>
            To cancel your subscription and stop future billing, please contact us at <b>info@youngpresso.com</b> with 
            your registered email address.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body1" paragraph sx={{ fontStyle: 'italic' }}>
            Last updated: April 26, 2025
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about our Cancellation and Refund Policy, please contact our support team at 
            info@youngpresso.com.
          </Typography>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default CancellationRefundPolicy;
